import { Point, Range } from 'slate';

export function CurrentWord(value) {
  const { focusBlock, selection } = value;
  const { text } = focusBlock;
  const currentOffset = selection.end.offset;
  let wordStart = text.substring(0, currentOffset).lastIndexOf(' ');
  let wordEnd = text.substring(currentOffset, text.length).indexOf(' ');
  wordStart = wordStart < 0 ? 0 : wordStart + 1;
  wordEnd = wordEnd < 0 ? text.length : currentOffset + wordEnd;
  const word = focusBlock.text.substring(wordStart, wordEnd);
  const anchor = new Point({ key: focusBlock.key, offset: wordStart });
  const focus = new Point({ key: focusBlock.key, offset: wordEnd });
  const range = new Range({ anchor, focus });
  return { word, range };
}
